import L from "leaflet";
import React from "react";
import { useEffect } from "react";
import ReactDOM from "react-dom";

const POSITION_CLASSES = {
  bottomleft: "leaflet-bottom leaflet-left",
  bottomright: "leaflet-bottom leaflet-right",
  topleft: "leaflet-top leaflet-left",
  topright: "leaflet-top leaflet-right",
  bottomrightSecondary: "leaflet-bottom-right-secondary",
  bottomleftSecondary: "leaflet-bottom-left-secondary"
};

type Props = {
  position:
    | "bottomleft"
    | "bottomright"
    | "topleft"
    | "topright"
    | "bottomrightSecondary"
    | "bottomleftSecondary";
  children: React.ReactNode | React.ReactNode[];
  appendType?: "before" | "after";
};

export const ControlPortalContent = ({
  position,
  children,
  appendType = "before"
}: Props): JSX.Element => {
  const positionClass =
    (position && POSITION_CLASSES[position]) || POSITION_CLASSES.topright;

  const portalContainer = document.createElement("div");

  useEffect(() => {
    const divAtScreen = document.getElementsByClassName(positionClass);
    if (divAtScreen[0] && portalContainer) {
      if (appendType == "before") {
        divAtScreen[0].prepend(portalContainer);
      }
      if (appendType == "after") {
        divAtScreen[0].append(portalContainer);
      }
    } else {
      const containerControls = document.getElementsByClassName(
        "leaflet-control-container"
      )[0];
      const newPositionContainer = document.createElement("div");
      newPositionContainer.classList.add(positionClass);
      newPositionContainer.prepend(portalContainer);
      containerControls.prepend(newPositionContainer);
    }
  }, []);

  useEffect(
    () => () => {
      portalContainer.remove();
    },
    [portalContainer]
  );

  const controlContainer = Array.isArray(children) ? (
    children.map((x, i) => <div key={i}>{x}</div>)
  ) : (
    <div>{children}</div>
  );

  L.DomEvent.disableClickPropagation(portalContainer);

  return ReactDOM.createPortal(controlContainer, portalContainer);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function propsAreEqual(prev: any, next: any) {
  return prev.position === next.position;
}

export const ControlPortal = React.memo(ControlPortalContent, propsAreEqual);
